module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Crop Deliveries","noDeliveries":"No deliveries yet."},"es":{"title":"Entregas de Cultivos","noDeliveries":"Aún no hay entregas"},"sw":{"title":"Uwasilishaji wa Mazao","noDeliveries":"Hakuna wanaojifungua bado."}}')
  delete Component.options._Ctor
}
